interface SaleorThrobberProps {
  size?: number;
  className?: string;
  "data-test-id"?: string;
}

const marcGreen = "#10B981";

export function SaleorThrobber({
  size = 40,
  className,
  "data-test-id": dataTestId,
}: SaleorThrobberProps) {
  const strokeWidth = Math.max(1.5, Math.round(size * 0.07 * 10) / 10);
  const radius = 20 - strokeWidth / 2;

  return (
    <div
      className={className}
      data-test-id={dataTestId}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="Loading"
        role="progressbar"
      >
        <style>
          {`
            @keyframes throbberSpin {
              100% { transform: rotate(360deg); }
            }
          `}
        </style>

        <circle
          cx="20"
          cy="20"
          r={radius}
          stroke={marcGreen}
          strokeWidth={strokeWidth}
          opacity={0.2}
        />
        <circle
          cx="20"
          cy="20"
          r={radius}
          stroke={marcGreen}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray="72 110"
          style={{
            transformOrigin: "50% 50%",
            animation: "throbberSpin 0.85s linear infinite",
          }}
        />
      </svg>
    </div>
  );
}
